// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"7cc33611","200":"5a386ef6","257":"730d4ea3","260":"16c99883","328":"81752156","416":"8d03f537","687":"071e48f0"}[chunkId] + ".chunk.js";
};